import React, { memo } from "react";
import { Dialog, DialogContent, DialogTitle } from "investira.react.components";
import { useRelatorioContext } from "../../../contexts/RelatorioContext";
import DurationParams from "../_params/DurationParams";
import EnquadramentoParams from "../_params/EnquadramentoParams";
import VarParams from "../_params/VarParams";

const ReportParamsDialog = memo((props) => {
  const { carteiras, output } = props;
  const { state } = useRelatorioContext();

  const OUTPUTS = {
    duration: DurationParams,
    enquadramento: EnquadramentoParams,
    var: VarParams,
  };

  const OutputParamsComponent = OUTPUTS[output];

  return (
    <Dialog open={state.isDialogOpen} maxWidth="sm">
      <DialogTitle>Nova Consulta</DialogTitle>
      <DialogContent>
        <OutputParamsComponent carteiras={carteiras} />
      </DialogContent>
    </Dialog>
  );
});

export default ReportParamsDialog;
